import { Observable } from 'rxjs';
import Paginate from '../interfaces/paginate';
import { HttpClient, ListParams } from './http-client';
import {
  AllEquipmentFormFields,
  MachineAndAggregateFields,
  SelfPropelledMachineryFields,
} from '../interfaces/equipment';

export class EquipmentService extends HttpClient {
  index(farmId: string, params: ListParams): Observable<Paginate<any>> {
    return this.get<Paginate<any>>(`/api/farms/${farmId}/equipment`, params);
  }

  show(farmId: string, id: string): Observable<AllEquipmentFormFields> {
    return this.get<AllEquipmentFormFields>(
      `/api/farms/${farmId}/equipment/${id}`
    );
  }

  store(
    farmId: string,
    value: SelfPropelledMachineryFields & MachineAndAggregateFields
  ): Observable<SelfPropelledMachineryFields & MachineAndAggregateFields> {
    return this.post<SelfPropelledMachineryFields & MachineAndAggregateFields>(
      `/api/farms/${farmId}/equipment`,
      value
    );
  }

  update(
    farmId: string,
    id: string,
    value: SelfPropelledMachineryFields & MachineAndAggregateFields
  ): Observable<SelfPropelledMachineryFields & MachineAndAggregateFields> {
    return this.put<SelfPropelledMachineryFields & MachineAndAggregateFields>(
      `/api/farms/${farmId}/equipment/${id}`,
      value
    );
  }
}
